import { SINGLE_PAGE_TABLE_SKELETON_HEIGHT, SINGLE_PAGE_TABLE_SKELETON_ROWS } from 'Util/constants'
import { LinearProgress, Skeleton } from '@mui/material'
import { Box } from '@mui/system'
import type { ReactNode } from 'react'

export default function Loader({
  loading,
  children,
  height = SINGLE_PAGE_TABLE_SKELETON_HEIGHT,
  rows = SINGLE_PAGE_TABLE_SKELETON_ROWS
}: Readonly<{
  loading: boolean
  children: ReactNode
  height?: number
  rows?: number
}>) {
  return loading ? (
    <Box>
      <LinearProgress />
      {Array.from({ length: rows }, (_x, i) => (
        <Skeleton key={i} height={height} animation="wave" />
      ))}
    </Box>
  ) : (
    <>{children}</>
  )
}
